'use client';

import { useSearchParams } from 'next/navigation';
import { registrarEvento } from '@/services/googleAnalytics';
// import { IconeGoogleLogin } from '@/components/atoms/Icones/IconeGoogleLogin';
import LoginForm from './components/organisms/LoginForm';
import Heading from '@/components/atoms/Heading';
import Button from '@/components/atoms/Button';
import { theme } from '@/styles/theme';
// import styled from 'styled-components';
import useBreakpoint from '@/hooks/useBreakpoint';
import useLogarScreenHook from './hook/useLogarScreenHook';
import redirecionarUsuario from '@/helpers/navigation/redirecionarUsuario';
import { signIn } from 'next-auth/react';
import { ContainerPrincipalFluxoAutenticacao } from '@/components/organisms/ModalJornadaGuiadaMinhaCarteira/components/pages/Autenticacao/components/molecules/ContainerPrincipalFluxoAutenticacao';
import { IconeGoogleColorido } from '@/components/atoms/Icones/IconeGoogleColorido';
import { ContainerFundoComVerdeEscuro } from '@/components/organisms/ModalJornadaGuiadaMinhaCarteira/components/pages/Autenticacao/components/molecules/ContainerFundoComVerdeEscuro';
import { useMetaTrackHook } from '@/hooks/useMetaTrackHook';

export interface LogarData {
  email: string;
  senha: string;
}

// const Container = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: ${({ theme }) => `${theme.spacing[5]}px ${theme.spacing[4]}px`};
//   gap: ${({ theme }) => theme.spacing[5]}px;
// `;

export default function Logar() {
  const searchParams = useSearchParams();

  const { realizarLogin, carregando } = useLogarScreenHook();

  const { breakpoint } = useBreakpoint();

  const { enviarEventosMetaTrack } = useMetaTrackHook();

  async function onSubmit(formLogar: LogarData) {
    const podeAvancar = await realizarLogin(formLogar);

    if (podeAvancar) {
      const callbackUrl = searchParams.get('callbackUrl');
      enviarEventosMetaTrack('login_success');
      return redirecionarUsuario(callbackUrl);
    } else {
      enviarEventosMetaTrack('login_error');
    }
  }

  async function logarComGoogle() {
    registrarEvento('login_google', {});

    const callbackUrl = searchParams.get('callbackUrl');

    await signIn('google', {
      redirect: true,
      callbackUrl: callbackUrl ?? '/',
    });
  }

  // if (breakpoint === 'mobile') {
  return (
    <ContainerPrincipalFluxoAutenticacao
      style={{
        width: '100%',
        position: 'initial',
        padding: `${theme.spacing[5]}px ${theme.spacing[4]}px`,
      }}
      $breakpoint={breakpoint}
    >
      <ContainerFundoComVerdeEscuro />
      <Heading
        $priority={1}
        $size={6}
        $color="neutral"
        $weight="bold"
        $align={breakpoint === 'mobile' ? 'left' : 'center'}
        $highContrast={true}
        $text="Acesse sua conta"
        style={{
          width: '100%',
        }}
      />
      <LoginForm
        corBotaoLogar="accent"
        corTextosAcao="accent"
        BotaoLoginComGoogle={
          <Button
            $size={2}
            $variant="solid"
            $color="neutral"
            $highContrast={true}
            $IconStart={IconeGoogleColorido}
            $focusRing={false}
            $text="Google"
            style={{
              justifyContent: 'center',
              color: theme.colors.default.black,
            }}
            $iconStartProps={{
              size: theme.typography.font.size[5],
            }}
            $loading={false}
            $onClick={logarComGoogle}
          />
        }
        carregando={carregando}
        onSubmit={onSubmit}
        tamanhosInput={1}
        style={{
          width: breakpoint === 'mobile' ? '100%' : 400,
          zIndex: 2,
          backgroundColor: theme.colors.accent.accent[3],
          padding: `0px ${theme.spacing[4]}px`,
          paddingTop: theme.spacing[4],
          borderRadius: theme.radius[3],
        }}
        formStyle={{
          gap: theme.spacing[3],
        }}
      />
    </ContainerPrincipalFluxoAutenticacao>
  );
  // }

  // return (
  //   <Container
  //     style={{
  //       ...breakpointDesktopDefault,
  //       maxWidth: 700,
  //     }}
  //   >
  //     <Heading
  //       $priority={1}
  //       $size={6}
  //       $color="neutral"
  //       $weight="bold"
  //       $align="left"
  //       $highContrast={true}
  //       $text="Acesse sua conta"
  //     />
  //     <LoginForm
  //       corBotaoLogar="accent"
  //       corTextosAcao="accent"
  //       BotaoLoginComGoogle={
  //         <Button
  //           $size={2}
  //           $variant="soft"
  //           $color="neutral"
  //           $highContrast={true}
  //           $IconStart={IconeGoogleLogin}
  //           $focusRing={false}
  //           $text="Google"
  //           style={{
  //             justifyContent: 'center',
  //           }}
  //           $iconStartProps={{
  //             size: theme.typography.font.size[5],
  //           }}
  //           $loading={false}
  //           $onClick={logarComGoogle}
  //         />
  //       }
  //       carregando={carregando}
  //       onSubmit={onSubmit}
  //     />
  //   </Container>
  // );
}
